import React, { lazy, Suspense } from 'react'
import styled from 'styled-components';

import img1 from '../../assets/Nfts/download (10).jpg';
import img2 from '../../assets/Nfts/download (4).jpg';
import img3 from '../../assets/Nfts/download (5).jpg';
import img4 from '../../assets/Nfts/download (6).jpg';
import img5 from '../../assets/Nfts/download (7).jpg';
import img6 from '../../assets/Nfts/download (8).jpg';
import img7 from '../../assets/Nfts/download (9).jpg';
import img8 from '../../assets/Nfts/DesignGeo_Art_+_Design_Exclusive_Digital_Artworks_created_by_pixel.jpg';
import img9 from '../../assets/Nfts/PINTEREST.jpg';
// import img10 from '../assets/Nfts/5052_eth.jpg';
import Loading from '../Loading';
// import ConfettiComponent from '../Confetti';

const ConfettiComponent = lazy(() => import("../Confetti"));


const Section = styled.section`
min-height: 100vh;
width: 100vw;
background-color: ${props => props.theme.body};
position: relative;
overflow: hidden;
`
const Title = styled.h1`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  color: ${(props) => props.theme.text};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  border-bottom: 2px solid ${(props) => props.theme.text};
  width: fit-content;

  @media (max-width: 40em){
    font-size: ${(props) => props.theme.fontxl};

}
`;

const Container = styled.div`
width: 75%;
margin: 2rem auto;

display: flex;
justify-content: space-between;
align-items: center;
flex-wrap: wrap;

@media (max-width: 64em){
width: 80%;
}
@media (max-width: 48em){
width: 90%;
justify-content: center;
}
`

const Item = styled.div`
width: calc(20rem - 4vw);
padding: 1rem 0;
color: ${props => props.theme.body};
margin: 2rem 1rem;
position: relative;
z-index:5;

backdrop-filter: blur(4px);

border: 2px solid ${props => props.theme.text};
border-radius: 20px;

&:hover{
  img{
    transform: translateY(0rem) scale(1.2);
  }
}

@media (max-width: 30em){
width: 70vw;
}

`

const ImageContainer = styled.div`
width: 80%;
margin: 0 auto;
background-color:${props => props.theme.carouselColor};
border: 1px solid ${props => props.theme.text};
padding: 1rem;
overflow: hidden;

border-radius: 20px;
cursor: pointer;

img{
  width: 220px;
  border-radius: 20px;
  height: 200px;
transition: all 0.3s ease;

}
`

const Name = styled.h2`
font-size: ${props => props.theme.fontlg};
display: flex;
align-items: center;
justify-content: center;
text-transform: uppercase;
color: ${props => props.theme.text};
margin-top: 1rem;
`

const Position = styled.h2`
font-size: ${props => props.theme.fontmd};
display: flex;
align-items: center;
justify-content: center;
text-transform: capitalize;
color: ${props => `rgba(${props.theme.textRgba},0.9)`};
font-weight:400;
`

const MemberComponent = ({img, name=" ",position=" "}) => {

  return(
    <Item>
      <ImageContainer>
        <img width={500} height={400}  src={img} alt={name} />
      </ImageContainer>
      <Name>{name}</Name>
      <Position>{position}</Position>
    </Item>
  )
}


const Team = () => {
  return (
    <Section id="team">
    <Suspense fallback={<Loading />}>
    <ConfettiComponent  /> </Suspense>
      <Title>Best Sellers</Title>
      <Container>
        <MemberComponent img={img1}  name="HEVEN" position="65x" />
        <MemberComponent img={img2}  name="MEGNUM" position="61x" />
        <MemberComponent img={img3}  name="GENESIS" position="59x" />
        <MemberComponent img={img4}  name="DUNE" position="41x" />
        <MemberComponent img={img5}  name="DEATHSTROKE" position="31x" />
        <MemberComponent img={img6}  name="LEUKO KING" position="28x" />
        <MemberComponent img={img7}  name="LOST CROWN" position="27.5x" />
        <MemberComponent img={img8}  name="LUXURY TED" position="27x" />
        <MemberComponent img={img9}  name="G.T.A 6" position="26.9 X" />
        

      </Container>
    </Section>
  )
}

export default Team